
import alreadyAllocated from './allocation/alreadyAllocated.vue';

if (document.querySelector('#already-allocated')) {
    const alreadyAllocationElem = document.querySelector('#already-allocated');
    const alreadyAllocationElemData = JSON.parse(alreadyAllocationElem.dataset.orders);
    var app = new Vue({
        el: '#already-allocated',
        template: '<alreadyAllocated :alreadyAllocatedData="alreadyAllocatedData"/>',
        data(){
          return {
              alreadyAllocatedData: alreadyAllocationElemData,
          }
        },
        created() {
            window.vue = this;
        },
        mounted() {
        },
        components: {alreadyAllocated},
    });
}